import { render } from "./EartagOverview.vue?vue&type=template&id=3d22349a&scoped=true"
import script from "./EartagOverview.vue?vue&type=script&lang=js"
export * from "./EartagOverview.vue?vue&type=script&lang=js"

import "./EartagOverview.vue?vue&type=style&index=0&id=3d22349a&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d22349a"]])

export default __exports__